import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { errorMessage } from "../../../../../utils/errorMessage";

// Create an asynchronous thunk using createAsyncThunk
export const actionAdminToUpdateCurrentAccountPurchaseLimits = createAsyncThunk(
  "updateCurrentAccountPurchaseLimits",
  async (updateData, thunkAPI) => {
    // GET JWT TOKEN FROM REDUX STORE
    const token = thunkAPI.getState().adminUserToLogin.adminUserInfo.token; // Gets the current Redux state

    try {
      // Call your API function here
      const { data } = await axios.put(
        "/api/wholesale/updateCurrentAccountPurchaseLimits",
        updateData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // Assuming the API response contains the data
      return data;
    } catch (error) {
      let { message } = errorMessage(error);
      throw new Error(message);
    }
  }
);

// Define an initial state for the slice
const initialState = {
  updatedCurrentAccountPurchaseLimits: null,
  loading: false,
  error: null,
};

// Create a slice using createSlice
const updateCurrentAccountPurchaseLimitsSlice = createSlice({
  name: "updateCurrentAccountPurchaseLimits",
  initialState,
  reducers: {
    resetUpdateCurrentAccountPurchaseLimits: (state) => {
      state.updatedCurrentAccountPurchaseLimits = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        actionAdminToUpdateCurrentAccountPurchaseLimits.pending,
        (state) => {
          state.loading = true;
        }
      )
      .addCase(
        actionAdminToUpdateCurrentAccountPurchaseLimits.fulfilled,
        (state, action) => {
          state.loading = false;
          state.updatedCurrentAccountPurchaseLimits = action.payload;
        }
      )
      .addCase(
        actionAdminToUpdateCurrentAccountPurchaseLimits.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        }
      );
  },
});

// Export reset method
const { resetUpdateCurrentAccountPurchaseLimits } =
  updateCurrentAccountPurchaseLimitsSlice.actions;

// Export the reducer
const reducerAdminToUpdateCurrentAccountPurchaseLimits =
  updateCurrentAccountPurchaseLimitsSlice.reducer;

// Export the async action creator for use in components
export {
  reducerAdminToUpdateCurrentAccountPurchaseLimits,
  resetUpdateCurrentAccountPurchaseLimits,
};
